import { TTreeHeading } from '../tiptap/nodes/heading/HeadingNode';
import { THeading } from '../types';

const flattenTreeHeadings = (headings: TTreeHeading[], apiHeadings: THeading[] = []): THeading[] => {
  for (const heading of headings) {
    apiHeadings.push({
      id: heading.id,
      text: heading.text,
      level: heading.level,
      numbering: heading.numbering,
    });
    flattenTreeHeadings(heading.children, apiHeadings);
  }
  return apiHeadings;
};

export default flattenTreeHeadings;
